import {
  Search,
  LineChart,
  LayoutGrid,
  Activity,
  FileCheck,
} from "lucide-react";

const AI_IMG =
  "https://static.prod-images.emergentagent.com/jobs/7662fa13-a20c-42f4-8e5d-f8666613b6c9/images/c34946f24ef309e056770efe105e25a0aaffa1dadf6fbeea3104900f8a760f68.png";

const pillars = [
  {
    title: "Prospección y Selección de Stock",
    desc: "Evaluamos y seleccionamos productos de fabricantes confiables, analizando su potencial de demanda y viabilidad comercial en el mercado al por mayor y menor.",
    icon: Search,
  },
  {
    title: "Sincronización Predictiva de Inventarios",
    desc: "Diagnosticamos cada punto de venta para asignar la cantidad exacta de mercancía, optimizando el espacio en anaquel y reduciendo al mínimo el costo de almacenamiento.",
    icon: LineChart,
  },
  {
    title: "Colocación y Merchandising Estratégico",
    desc: "Distribuimos el stock bajo modelos de venta directa o consignación, asegurando una exhibición atractiva en el punto de venta para acelerar el ciclo de compra.",
    icon: LayoutGrid,
  },
  {
    title: "Monitoreo de Rotación en Tiempo Real",
    desc: "Supervisamos el desplazamiento diario de las mercancías, lo que nos permite reaccionar rápido para resurtir los productos de alta demanda y evitar el desabasto.",
    icon: Activity,
  },
  {
    title: "Liquidación Transparente y Reportes",
    desc: "Concluimos el ciclo con rendiciones de cuentas claras y pagos puntuales a nuestros proveedores, ofreciéndoles visibilidad total sobre el estatus y éxito de sus productos.",
    icon: FileCheck,
  },
];

const SmartConnect = () => {
  return (
    <section
      id="metodologia"
      data-testid="metodologia-section"
      className="relative bg-black text-white py-24 lg:py-32 overflow-hidden grain"
    >
      <div className="blob bg-[#F3901A] w-[500px] h-[500px] top-[20%] left-[-150px] opacity-25" />
      <div className="blob bg-[#C7343D] w-[500px] h-[500px] bottom-[-100px] right-[-100px] opacity-25" />

      <div className="relative max-w-[1500px] mx-auto px-6 lg:px-12">
        <div className="flex items-center gap-4 mb-12">
          <div className="h-px w-12 bg-[#F3901A]" />
          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-[#F3901A]">
            Metodología · ¡Conócenos y hagamos equipo!
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 mb-20 items-end">
          <div className="lg:col-span-7">
            <h2
              data-testid="metodologia-heading"
              className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-light tracking-[-0.03em] leading-[1] text-white text-balance"
            >
              La{" "}
              <span className="italic font-extralight text-[#F3901A]">
                metodología
              </span>{" "}
              de trabajo <span className="text-[#C7343D]">Sacaru</span>
            </h2>
            <p className="mt-8 text-white/70 leading-relaxed text-lg font-light max-w-2xl">
              Un proceso de cinco pasos diseñado para conectar productos con
              mercados de forma ágil, transparente y rentable, asegurando la
              rotación constante del inventario en cada punto de venta.
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="relative h-[280px] lg:h-[340px] overflow-hidden border border-white/10">
              <img
                src={AI_IMG}
                alt="Metodología Sacaru"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/80 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 text-xs uppercase tracking-[0.3em] text-white/80">
                Stock · Rotación · Liquidación
              </div>
            </div>
          </div>
        </div>

        {/* Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {pillars.map((p, i) => {
            const Icon = p.icon;
            const isLast = i === pillars.length - 1;
            return (
              <div
                key={p.title}
                data-testid={`pillar-${i}`}
                className={`pillar-card bg-black p-8 lg:p-10 min-h-[280px] flex flex-col justify-between border border-transparent ${
                  isLast ? "lg:col-span-2" : ""
                }`}
              >
                <div className="flex items-start justify-between">
                  <Icon
                    size={32}
                    strokeWidth={1.25}
                    className="text-[#F3901A]"
                  />
                  <span className="text-xs text-white/30 numeric">
                    0{i + 1} / 05
                  </span>
                </div>
                <div>
                  <h3 className="font-display text-xl lg:text-2xl text-white font-normal tracking-tight leading-tight mb-3">
                    {p.title}
                  </h3>
                  <p className="text-white/60 text-sm leading-relaxed">
                    {p.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SmartConnect;
